import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Star } from "lucide-react";

const fmt2 = (n) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt4 = (n) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });

export default function CustomerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/customers/${id}`).then(r => setData(r.data)); }, [id]);
  if (!data) return <div>Yükleniyor…</div>;
  const { customer, history, vault } = data;

  return (
    <div className="space-y-6" data-testid="customer-detail">
      <Link to="/customers" className="label-caps hover:text-[--gold] flex items-center gap-2"><ArrowLeft size={12} /> Müşteriler</Link>
      <div className="flex items-baseline justify-between">
        <div>
          <div className="flex items-center gap-2 label-caps">
            {customer.segment === "vip" && <Star size={14} style={{color:"var(--gold)"}} fill="currentColor" />}
            {customer.segment.toUpperCase()}
          </div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 font-light">{customer.name}</h1>
          <div className="text-neutral-400 mt-2 font-mono">{customer.phone} · {customer.email}</div>
        </div>
        <div className="text-right">
          <div className="label-caps">Emanet Bakiye</div>
          <div className="font-mono text-3xl mt-2 tabular-nums" style={{color:"var(--gold)"}}>{fmt4(vault?.total_gram_pure)} gr</div>
        </div>
      </div>

      <div className="card-flat p-6">
        <div className="label-caps mb-4">İşlem Geçmişi ({history.length})</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-neutral-500 label-caps border-b border-white/5">
              <th className="text-left py-3">Tarih</th>
              <th className="text-left py-3">Tür</th>
              <th className="text-left py-3">Ödeme</th>
              <th className="text-right py-3">Tutar</th>
            </tr>
          </thead>
          <tbody>
            {history.map(t => (
              <tr key={t.id} className="border-b border-white/5">
                <td className="py-3 text-neutral-400">{new Date(t.created_at).toLocaleString("tr-TR")}</td>
                <td className="py-3">{t.type === "sale" ? "Satış" : t.type === "scrap_buy" ? "Hurda Alım" : t.type}</td>
                <td className="py-3">{t.payment_method}</td>
                <td className="py-3 text-right font-mono tabular-nums" style={{color:"var(--gold)"}}>{fmt2(t.total_amount_tl)} ₺</td>
              </tr>
            ))}
            {history.length === 0 && <tr><td colSpan={4} className="text-center py-6 text-neutral-500">İşlem yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
